import React, { useState, useMemo } from 'react'
import { Tooltip } from '@mui/material';
import Iconify from '../../common/iconify/Iconify';
import { getAllNodeTypes } from '../nodes/registry';
import '../nodes/types';  // side-effect: registers all question types

// Category definitions — group node types logically
const CATEGORIES = {
    input: {
        label: 'Input',
        types: ['TEXT_FIELD', 'TEXT_AREA', 'DROPDOWN_TEXT_FIELD'],
    },
    selection: {
        label: 'Selection',
        types: ['RADIO', 'CHECKBOX', 'DROPDOWN'],
    },
    media: {
        label: 'Media',
        types: ['IMAGELIST', 'RATING', 'CALENDAR'],
    },
}

/**
 * NodePalette — draggable question type palette (left vertical toolbar).
 * Renders all registered question types grouped by category.
 * Inspired by n8n's node palette.
 */
export default function NodePalette() {
    const [search, setSearch] = useState('')

    const allTypes = useMemo(() => getAllNodeTypes(), [])

    const filteredCategories = useMemo(() => {
        const q = search.toLowerCase().trim()
        return Object.entries(CATEGORIES).map(([key, cat]) => {
            const items = cat.types
                .map(type => allTypes.find(t => t.type === type))
                .filter(Boolean)
                .filter(t => !q || t.label.toLowerCase().includes(q) || t.type.toLowerCase().includes(q))
            return { key, label: cat.label, items }
        }).filter(cat => cat.items.length > 0)
    }, [search, allTypes])

    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className='toolbar'>
            <input
                className='toolbar-search'
                type='text'
                placeholder='Filter...'
                value={search}
                onChange={e => setSearch(e.target.value)}
            />
            {filteredCategories.map(cat => (
                <React.Fragment key={cat.key}>
                    <div className='toolbar-category'>{cat.label}</div>
                    {cat.items.map(({ type, label, icon, color }) => (
                        <Tooltip key={type} title={label} placement="right" arrow>
                            <div className='toolbar-item' draggable onDragStart={(e) => onDragStart(e, type)}>
                                <Iconify icon={icon} sx={{ width: 18, height: 18, color: color }} />
                                <span className='toolbar-item-label'>{label}</span>
                            </div>
                        </Tooltip>
                    ))}
                </React.Fragment>
            ))}
        </div>
    )
}
